import { render, staticRenderFns } from "./BillableCategories.vue?vue&type=template&id=3894dd37&scoped=true"
import script from "./BillableCategories.vue?vue&type=script&lang=js"
export * from "./BillableCategories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3894dd37",
  null
  
)

export default component.exports